const actions = {
    setPulseLoader({
        commit
    }, visible) {
        commit('SET_PULSE_LOADER', visible)
    },
    setLoginVisible({
        commit
    }, visible) {
        commit('SET_LOGIN_VISIBLE', visible)
    },
    setQuestionTypeList({
        commit,
        rootGetters
    }) {
        commit('SET_QUESTION_TYPE_LIST', rootGetters)
    },
    setCurrentExpInfo({
        commit
    }, curExp) {
        commit('SET_CURRENT_EXP_INFO', curExp)
    },
    setRefresh({
        commit
    }, update) {
        commit('SET_REFRESH', update)
    }
}

export default actions